<app-modal title="Manager as a sales person" #modalComponent>
  <form (ngSubmit)="onSubmit()" #f="ngForm" class="p-3">

    <div class="form-check mb-2">
      <input class="form-check-input"
             name="salesPerson"
             id="salesPerson"
             type="checkbox"
             [(ngModel)]="canDoSales">
      <label class="form-check-label" for="salesPerson">
        Manager as a sales person
      </label>
    </div>

    <app-input-date
            [isDisabled]="weekExists()"
            [placeholder]="'Start date'"
            [name]="'startDate'"
            [(inputDate)]="startDate"
            [editDate]="editDate()"
            [onlyMondays]="true">
    </app-input-date>

    <div class="mt-4 text-end">
      <button class="btn btn-primary-outline btn-form me-3 close-button" type="button"
              (click)="modalComponent.activeModal.close()">Close
      </button>
      <button
              class="btn btn-primary btn-form save-button"
              type="submit"
              [disabled]="!f.valid || !startDate() || loading()">Save
      </button>
    </div>
  </form>
</app-modal>